// extracted by mini-css-extract-plugin
export var md = "_5w-4";
export var semantic = "_5w-5";
export var sm = "_5w-3";
export var text = "_5w-6";
export var toggleInput = "_5w-0";
export var toggleSwitch = "_5w-1";
export var xs = "_5w-2";